/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_RecipesInputs */

const en_shopping_recipes = /** @type {(inputs: Shopping_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipes on the list`)
};

const de_shopping_recipes = /** @type {(inputs: Shopping_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepte auf der Liste`)
};

/**
* | output |
* | --- |
* | "Recipes on the list" |
*
* @param {Shopping_RecipesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_recipes = /** @type {((inputs?: Shopping_RecipesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_RecipesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_recipes(inputs)
	return en_shopping_recipes(inputs)
});